import {Injectable, Injector} from '@angular/core'
import {HttpInterceptor} from '@angular/common/http'
import {AuthService} from '../auth/auth.service';

@Injectable()
export class HttpAuthInterceptor implements HttpInterceptor {

    constructor(private injector: Injector) {}

    intercept(req, next) {
        const auth = this.injector.get(AuthService)
        const authRequest = req.clone({
            headers: req.headers.set('Authorization', `Bearer ${auth.token}`)
        });
        return next.handle(authRequest)
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/interceptors/http-auth.interceptor.ts